import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAbonnementActions } from '../hooks/useAbonnements';
import abonnementService from '../services/abonnementService';
import '../styles/CreateAbonnement.css';

const CreateAbonnement = () => {
  const navigate = useNavigate();
  const { createPlan, loading } = useAbonnementActions();

  const [formData, setFormData] = useState({
    name: '',
    price: '',
    billing_period: 'monthly'
  });

  const [features, setFeatures] = useState(abonnementService.getDefaultFeatures());
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFeatureChange = (featureId) => {
    setFeatures(prev => 
      prev.map(feature => 
        feature.id === featureId 
          ? { ...feature, checked: !feature.checked }
          : feature
      )
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.name || !formData.price) {
      setError('Veuillez remplir tous les champs obligatoires');
      return;
    }

    try {
      const planData = {
        ...formData,
        price: parseFloat(formData.price),
        features: abonnementService.featuresToObject(features),
        max_missions_per_month: null,
        commission_rate: 0
      };

      await createPlan(planData);
      navigate('/abonnements');
    } catch (error) {
      setError('Erreur lors de la création du plan');
    }
  };

  const handleCancel = () => {
    navigate('/abonnements');
  };

  return (
    <div className="create-abonnement-container">
      <div className="create-abonnement-header">
        <button className="back-button" onClick={handleCancel}>
          ← Créer un abonnement
        </button>
      </div>

      <form onSubmit={handleSubmit} className="create-abonnement-form">
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="name">Nom abonnement</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Ex : Gold"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="price">Montant</label>
            <input
              type="number"
              id="price"
              name="price"
              value={formData.price}
              onChange={handleInputChange}
              placeholder="Ex : 10 000 FCFA"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="billing_period">Durée</label>
            <select
              id="billing_period"
              name="billing_period"
              value={formData.billing_period}
              onChange={handleInputChange}
            >
              <option value="monthly">Mensuelle</option>
              <option value="quarterly">Trimestrielle</option>
              <option value="yearly">Annuelle</option>
            </select>
          </div>
        </div>

        <div className="features-section">
          <h3>Offre</h3>
          <div className="features-grid">
            <div className="features-column">
              {features.slice(0, Math.ceil(features.length / 2)).map((feature) => (
                <label key={feature.id} className="feature-checkbox">
                  <input
                    type="checkbox"
                    checked={feature.checked}
                    onChange={() => handleFeatureChange(feature.id)}
                  />
                  <span className="checkmark"></span>
                  {feature.label}
                </label>
              ))}
            </div>
            <div className="features-column">
              {features.slice(Math.ceil(features.length / 2)).map((feature) => (
                <label key={feature.id} className="feature-checkbox">
                  <input
                    type="checkbox"
                    checked={feature.checked}
                    onChange={() => handleFeatureChange(feature.id)}
                  />
                  <span className="checkmark"></span>
                  {feature.label}
                </label>
              ))}
            </div>
          </div>
        </div>

        {error && <div className="error-message">{error}</div>}

        <div className="form-actions">
          <button type="button" className="btn-cancel" onClick={handleCancel}>
            Annuler
          </button>
          <button type="submit" className="btn-submit" disabled={loading}>
            {loading ? 'Enregistrement...' : 'Enregistrer'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateAbonnement;